<!--视频内容-->
<template>
  <div class="video-info">
    <el-row>
      <el-col v-for="(video,index) of dataBase" class="video-list" :span="8" v-if="video.type!=3">
        <div @click="details(video)">
          <el-image :src="video.photo[0]"></el-image>
          <i class="iconfont icon-bofang"></i>
          <p class="title-default">{{video.title}}</p>
          <el-row>
            <el-col :span="4">
              <el-avatar :size="40" :src="video.user_avatar"></el-avatar>
            </el-col>
            <el-col :span="20" class="video-user" style="line-height: 42px;">
              <div class="small-span">{{ video.user_name }}</div>
              <div class="span-default">{{ video.view }}次播放 · </div>
              <div class="span-default">{{ video.time }}</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import {recommendLists} from "@/api/interfaceApi";
export default {
  name: "videoInfo",
  components:{page},
  data() {
    return {
      dataBase: [],
      cid:0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '2'
      }
    },
    activeTabs:{
      type:Object,
      default() {
        return {
          epidemic_url: "",
          image: "",
          is_epidemic: 0,
          is_local: 0,
          name: "推荐",
          nid: '2',
          no: 0,
        };
      }
    },
    cityList:{
      type:Object,
      default(){
        return {
          id: 500000,
          lat: 29.533155,
          level: 1,
          lng: 106.504959,
          name: "重庆",
          pid: 0,
          short_name: "重庆"
        }
      }
    }
  },
  watch: {
    activeIndex: function (val, oldVal) {
      this.tablePage.currentPage=1;
      this.getInfo();
    }
  },
  methods:{
    details(row){
      let routeData = this.$router.resolve({
        name: "videoDetails",
        query:{
          id:row.id,
          type:row.type,
        },
        params:{cid:this.cid},
        path: '/article/videoDetails',
      });
      window.open(routeData.href, '_blank')
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInfo();
    },
    /*获取列表数据*/
    getInfo(){
      let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      recommendLists({
        advLat: this.cityList.lng,
        advLng: this.cityList.lat,
        advNetwork: 4,
        advPlatform: 3,
        city: this.cityList.id,
        nid: 91,
        page: this.tablePage.currentPage,
        cid:cid!=0 && cid!=undefined ? cid : 0,
        uid:cid!=0 && cid!=undefined ? cid : 0
      }).then(res=>{
        if (res.code==200){
          window.scrollTo(0, 0);
          this.dataBase=res.content;
          this.tablePage.total=res.total;
        }
      })
    }
  },
  mounted() {
    this.getInfo();
  }
}
</script>

<style scoped lang="scss">
.video-info {
  min-height: 300px;
  padding-top: 20px;
  .video-list{
    padding-bottom: 20px;
    padding-right: 20px;
    .el-image{
      height: 228px;
      width: 100%;
      border-radius: 6px;
    }
    .title-default{
      font-size: 18px;
      font-family: "SourceHanSansCN";
      font-weight: 100;
      color: #333333;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      word-wrap: break-word;
      height: 48px;
      margin-block-end: 0px;
      margin-bottom: 5px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .span-default {
      color: #999999;
      font-size: 14px;
      font-family: 'SourceHanSansCN';
      font-weight: 100;
    }
    .video-user{
      display: flex;
      justify-content: left;
      .small-span{
        color: #333333;
        font-size: 16px;
        padding-right: 20px;
        width: 40%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        word-wrap: break-word;
        height: 48px;
        margin-block-end: 0px;
        margin-bottom: 5px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .icon-bofang{
      font-size: 45px;
      color: white;
      margin-top: 8%;
      position: absolute;
      margin-left: -18.2%;
    }
  }
}
</style>